import { render, staticRenderFns } from "./processView.vue?vue&type=template&id=c22315f0&scoped=true"
import script from "./processView.vue?vue&type=script&lang=js"
export * from "./processView.vue?vue&type=script&lang=js"
import style0 from "./processView.vue?vue&type=style&index=0&id=c22315f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22315f0",
  null
  
)

export default component.exports